module.exports = __webpack_public_path__ + "img/text-block.bc4a56d3.svg";